'use client';

import MobileDrawer from '@c/drawers/MobileDrawer';
import BaseModal from '@c/modals/BaseModal';
import Button from '@ui/Button';
import { isMobile } from '@util/index';
import { ProductDocument } from 'models/product';

export default function SmartPricingOffModal({
  open,
  setOpen,
  product: product,
  updateFloorPrice,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  product: ProductDocument;
  updateFloorPrice: (
    floorPrice: number | undefined,
    product: ProductDocument
  ) => void;
}) {
  const content = (
    <div className="flex flex-col justify-between gap-8 p-8 sm:h-[25rem]">
      <div className="flex flex-col gap-y-2">
        <span className="hidden items-center gap-[1.6rem] text-[2.4rem] font-medium sm:flex">
          Are you sure?
        </span>
        <span className="max-w-[40rem] pt-6 text-[2rem] text-brand-dark-gray">
          Are you sure you want to turn off smart pricing for this product?
        </span>
      </div>

      <div className="flex w-full justify-end gap-x-2">
        <Button text="Cancel" onClick={() => setOpen(false)} type="tertiary" />

        <Button
          text="Turn Off"
          onClick={() => {
            updateFloorPrice(undefined, product);
          }}
          type="secondary"
        />
      </div>
    </div>
  );

  if (isMobile()) {
    return (
      <MobileDrawer
        show={open}
        dismiss={() => setOpen(false)}
        title="Are you sure?"
      >
        {content}
      </MobileDrawer>
    );
  }

  return (
    <BaseModal isOpen={open} dismiss={() => setOpen(false)} hideCloseIcon>
      {content}
    </BaseModal>
  );
}
